import { ChangeDetectorRef, Component, NgZone, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Visitor } from '../../models/visitor';
import { VisitorService } from '../../services/visitor.service';
import { map } from 'rxjs/operators';
import { VisitorChild } from '../../models/visitorChild';
import { Visitor1 } from '../../models/visitor1';
import { VisitorChild1 } from '../../models/visitorChild1';
import { Visit } from '../../models/visit.model';
import { VisitService } from '../../services/visit.service';
import { PlayroomService } from '../../services/playroom.service';
import { NavController, Platform, ToastController } from '@ionic/angular';
import { Playroom } from '../../models/playroom.model';
import { CostumArray } from '../../models/customArray';
import { RoomArray } from '../../models/roomArray';
import { ZoneArray } from '../../models/zoneArray';
import { Zone } from '../../models/zone.model';
import { RodjendanskezoneService } from '../../services/rodjendanskezone.service';
import { BirthDay } from '../../models/birthday.model';
import { User } from 'src/app/models/user.model';
import { UserService } from '../../services/user.service';
import { validateBirthDay } from 'src/app/utils/formValidators';
import { CommonMethodesService } from '../../services/common-methodes.service';
import { CalendarWeek } from '../../models/CalendarWeek';
import { TimeSlotConfigurationService } from '../../services/time-slot-configuration.service';
import { CalendarSlotCell } from '../../models/CalendarSlotCell';
import { SlotsbyDate } from '../../models/SlotsbyDate';
import { CallListService } from '../../services/call-list.service';
import { NotifierService } from 'angular-notifier';
import { LanguageService } from 'src/app/services/language.service';
import { BirthDayAddsArray } from '../../models/birthDayAddsArray';
import { BirthdayListService } from '../../services/birthday-list.service';
import { PaginationSettings } from '../../models/paginationsettings';

export interface BirthdayOutput {
  id: number;
  status: number;
}
@Component({
  selector: 'app-kartica-visitora',
  templateUrl: './kartica-visitora.page.html',
  styleUrls: ['./kartica-visitora.page.scss'],
})
export class KarticaVisitoraPage implements OnInit {
  //visitor: Visitor1;
  visitor: any = {}; // ili prazan objekat
  currentVisitorId: number | null = null;
  visits: Visit[]
  visitorCh: VisitorChild1[]

  itemsPerPage: number = 2147483647;
  isAddBirthay: boolean = false

  usernameQuery: string = '';
  fullNameQuery: string = '';

  emailQuery: string = '';
  phoneQuery: string = '';
  visitorStatusQuery: string = '';
  currentPage: number = 1;
  onlyChildren: boolean = false;
  marketingMessageQuery: string = '';

  message: string = ''

  constructor(private route: ActivatedRoute, private visitorService: VisitorService,
    private visitService: VisitService,
    private roomService: PlayroomService,
    private rodjendanskezoneservice: RodjendanskezoneService,
    private userService: UserService,
    private commonMethodsService: CommonMethodesService,
    private navCtrl: NavController,
    private timeSlotService: TimeSlotConfigurationService,
    private callListService: CallListService,
    private notifierService: NotifierService,
    private languageService: LanguageService,
    private birthdayListService: BirthdayListService,
    private ngZone: NgZone,
    private cd: ChangeDetectorRef,
    private router: Router,
    private toastController: ToastController

  ) { }

  visitors$ = this.visitorService.visitors$;
  visits$ = this.visitService.visit$
  errMsg = '';

  paginationSettings: PaginationSettings = {
    totalItems: 0,
    currentPage: 1,
    itemsPerPage: 20
  };
  paginationSettingsBirthday: PaginationSettings = {
    totalItems: 0,
    currentPage: 1,
    itemsPerPage: 10
  };
  paginationSettingsCalls: PaginationSettings = {
    totalItems: 0,
    currentPage: 1,
    itemsPerPage: 20
  };


  birthDateQuery: string = '';
  roomQuery: string = '';
  statusQuery: string = '';
  registrationDateFromQuery: string = ""
  registrationDateToQuery: string = ""
  dateQuery: string = '';
  dateQueryEnd: string = '';
  roomName: string = '';
  enterTimeQuery: string = '';
  enterTimeQueryEnd: string = '';
  packageTicketType: string = '';
  dateBirthFromQuery: string = ''
  dateBirthToQuery: string = ''
  visitorBirthMonthFromQuery: string = ""
  visitorBirthMonthToQuery: string = ""
  visitorBirthYearFromQuery: string = ""
  visitorBirthYearToQuery: string = ""


  timeZoneQuery: string = Intl.DateTimeFormat().resolvedOptions().timeZone;
  gratis: boolean
  gratisQuery: string = ""
  playroom: Playroom[]
  userList: Array<CostumArray>;
  selectedUser: CostumArray | null = null
  roomList: Array<RoomArray>;
  selectedRoom: RoomArray | null = null
  zoneList: Array<ZoneArray>
  selectedZone: ZoneArray | null = null
  birthdayAdd: BirthDay
  startTimeBirthdayQuery = ''
  endTimeBirthdayQuery = ''
  zone: Zone[]
  users: User[];
  messageError: string = ''
  errMsgInputTime: string = ''
  errMsgInputDate: string = ''
  availibleslots: SlotsbyDate[] = []
  isCreateMode = false;
  datumpoziva: string = ''

  birthdayAdds: { name: string; quantity: string; price: number; }[] = [
    { name: '', quantity: '', price: null }
  ];
  birthDayAdssPriceTotal: number = null
  createChildren: Array<{ fullName: string; birthDate: string }> = [
    { fullName: '', birthDate: '' },
  ];
  phonePrefixes = [
    { code: '+381', flag: 'rs' }, // Srbija  
    { code: '+387', flag: 'ba' }, // Bosna i Hercegovina
    { code: '+389', flag: 'mk' }, // Severna Makedonija  
    { code: '+385', flag: 'hr' }, // Hrvatska  
    { code: '+382', flag: 'me' }, // Crna Gora
    { code: '+7', flag: 'ru' }, // Rusija  
    { code: '+380', flag: 'ua' }, // Ukrajina  
    { code: '+49', flag: 'de' }, // Nemačka 
    { code: '+355', flag: 'al' }, // Albanija  
    { code: '+376', flag: 'ad' }, // Andora  
    { code: '+43', flag: 'at' }, // Austrija  
    { code: '+374', flag: 'am' }, // Jermenija  
    { code: '+32', flag: 'be' }, // Belgija   
    { code: '+359', flag: 'bg' }, // Bugarska  
    { code: '+357', flag: 'cy' }, // Kipar  
    { code: '+420', flag: 'cz' }, // Češka  
    { code: '+45', flag: 'dk' }, // Danska  
    { code: '+372', flag: 'ee' }, // Estonija  
    { code: '+358', flag: 'fi' }, // Finska  
    { code: '+33', flag: 'fr' }, // Francuska  
    { code: '+995', flag: 'ge' }, // Gruzija  
    { code: '+30', flag: 'gr' }, // Grčka  
    { code: '+36', flag: 'hu' }, // Mađarska  
    { code: '+354', flag: 'is' }, // Island  
    { code: '+353', flag: 'ie' }, // Irska  
    { code: '+39', flag: 'it' }, // Italija  
    { code: '+371', flag: 'lv' }, // Letonija  
    { code: '+423', flag: 'li' }, // Lihtenštajn  
    { code: '+370', flag: 'lt' }, // Litvanija  
    { code: '+352', flag: 'lu' }, // Luksemburg  
    { code: '+356', flag: 'mt' }, // Malta  
    { code: '+373', flag: 'md' }, // Moldavija  
    { code: '+377', flag: 'mc' }, // Monako  
    { code: '+31', flag: 'nl' }, // Holandija  
    { code: '+47', flag: 'no' }, // Norveška  
    { code: '+48', flag: 'pl' }, // Poljska  
    { code: '+351', flag: 'pt' }, // Portugal  
    { code: '+40', flag: 'ro' }, // Rumunija  
    { code: '+421', flag: 'sk' }, // Slovačka  
    { code: '+386', flag: 'si' }, // Slovenija  
    { code: '+34', flag: 'es' }, // Španija  
    { code: '+46', flag: 'se' }, // Švedska  
    { code: '+41', flag: 'ch' }, // Švajcarska  
    { code: '+44', flag: 'gb' }, // Velika Britanija  
    { code: '+90', flag: 'tr' },  // Turska
    { code: '+1', flag: 'us' }, // Sjedinjene Američke Države
    { code: '+1', flag: 'ca' }, // Kanada
    { code: '+61', flag: 'au' }  // Australija
  ];
  selectedPrefix = this.phonePrefixes[0]; // Default: +381 (Srbija)
  dropdownOpen = false;
  inputs = {
    fullName: "",
    ['fullNameChild1']: "",
    phone: "",
    phonePrefix: "+381",
    email: "",
    day: "",
    month: "",
    year: ""
  };

  birthdays$ = this.birthdayListService.birthdays$;
  calls$ = this.callListService.calls$;
  itemsPerPageLarge: number = 2147483647;
  birthdayListList = BirthDay
  cityQuery: string = ''
  roomNameQuery: string = '';
  birthdayZoneNameQuery: string = '';
  VisitorNameQuery: string = '';
  CallDateFromQuery: string = '';
  CallDateToQuery: string = '';
  AppointmentDateFromQuery: string = '';
  AppointmentDateToQuery: string = '';
  PlannedPriceFromQuery: string = '';
  PlannedPriceToQuery: string = '';
  PlannedChildNumberFromQuery: string = '';
  PlannedChildNumberToQuery: string = '';
  PresentChildNumberQuery: string = '';
  PresentChildNumberFromQuery: string = '';
  PresentChildNumberToQuery: string = '';
  TotalPricePaidQuery: string = '';
  TotalPricePaidFromQuery: string = '';
  TotalPricePaidToQuery: string = '';
  StatusCallQuery: string = '';
  NumberOfBirthdayFromQuery: string = ''
  NumberOfBirthdayToQuery: string = '';
  AdvancePaymentWillQuery: string = '';
  AdvancePricePaidFromQuery: string = ""
  AdvancePricePaidToQuery: string = ""
  pageSize: number = 2147483647;

  birthdayListQuery: {
    currentPage: number;
    itemsPerPage: number;
    VisitorIdQuery: number | null;
    cityQuery: string;
    roomNameQuery: string;
    birthdayZoneNameQuery: string;
    VisitorNameQuery: string;
    CallDateFromQuery: string;
    CallDateToQuery: string;
    AppointmentDateFromQuery: string;
    AppointmentDateToQuery: string;
    PricePerChildrenFromQuery: string;
    PricePerChildrenToQuery: string,
    PlannedChildNumberFromQuery: string;
    PlannedChildNumberToQuery: string;
    PresentChildNumberFromQuery: string;
    PresentChildNumberToQuery: string;
    TotalPricePaidFromQuery: string;
    TotalPricePaidToQuery: string;
    StatusCallQuery: string;
    NumberOfBirthdayFromQuery: string;
    NumberOfBirthdayToQuery: string;
    AdvancePaymentWillQuery: string;
    AdvancePricePaidFromQuery: string;
    AdvancePricePaidToQuery: string;
  } = {
      currentPage: 1,
      itemsPerPage: 10,
      VisitorIdQuery: null,
      cityQuery: '',
      roomNameQuery: '',
      birthdayZoneNameQuery: '',
      VisitorNameQuery: '',
      CallDateFromQuery: '',
      CallDateToQuery: '',
      AppointmentDateFromQuery: '',
      AppointmentDateToQuery: '',
      PricePerChildrenFromQuery: '',
      PricePerChildrenToQuery: '',
      PlannedChildNumberFromQuery: '',
      PlannedChildNumberToQuery: '',
      PresentChildNumberFromQuery: '',
      PresentChildNumberToQuery: '',
      TotalPricePaidFromQuery: '',
      TotalPricePaidToQuery: '',
      StatusCallQuery: '0',
      NumberOfBirthdayFromQuery: '',
      NumberOfBirthdayToQuery: '',
      AdvancePaymentWillQuery: '',
      AdvancePricePaidFromQuery: '',
      AdvancePricePaidToQuery: ''
    };
  callListQuery: {
    currentPage: number,
    itemsPerPage: number,
    dateFrom: string,
    dateTo: string,
    operatorExtension: string,
    status: string,
    phoneQuery: string,
    durationFromQuery: string,
    durationToQuery: string

  }
    = {
      currentPage: 1,
      itemsPerPage: 20,
      dateFrom: '',
      dateTo: '',
      operatorExtension: '',
      status: '',
      phoneQuery: '',
      durationFromQuery: '',
      durationToQuery: ''

    };

  async presentToast(message: string, color: 'success' | 'danger' = 'success') {
    const toast = await this.toastController.create({
      message,
      duration: 3000,
      color
    });

    await toast.present();
  }
 StatusList: number[] = [];
  PhoneCallStatusList: number[] = [];
operators: any[] = [];

 OperatorExtensionsList = []
  ngOnInit() {
   
   this.callListService.callPagination$
    .subscribe(pag => {
      if (!pag) return;
 this.paginationSettings = {
       totalItems: pag.totalItems,
  currentPage: this.paginationSettings.currentPage, 
  itemsPerPage: pag.itemsPerPage

      };
 
    });
  
    this.getOperatorsArray()

    this.StatusList = null;
    this.PhoneCallStatusList = null  
   
    this.birthdayAdd = new BirthDay();
    this.birthdayAdd.Discount = 0;
    this.fillEmployeeFromStorage();

    this.loadVisit()
    this.roomService.getAllPlayroomsSub().subscribe(data => {
      this.playroom = data;

      this.userList = this.commonMethodsService.mapPlayroomsToUserList(this.playroom);
      if (this.birthdayAdd.city !== null || '') {

        const foundUser = this.userList.find(u => u.display === this.birthdayAdd.city);
        if (foundUser) {
          this.selectedUser = foundUser;
          this.getReducedArray()
          if (this.birthdayAdd.roomId && this.roomList) {
            const foundRoom = this.roomList.find(
              r => parseInt(r.value) === this.birthdayAdd.roomId
            );
            if (foundRoom) {
              this.selectedRoom = foundRoom;
            }
          }

        }
        this.getReducedZoneArray()
      }
    });

    const navigation = this.router.getCurrentNavigation();
    const stateVisitor = navigation?.extras?.state?.['visitor'];
    const visitorId = this.route.snapshot.paramMap.get('id');
    this.isCreateMode = !visitorId;
    this.currentVisitorId = visitorId ? parseInt(visitorId, 10) : null;

    if (stateVisitor) {

      this.visitor = stateVisitor;
      if (this.visitor?.id) {
        this.currentVisitorId = Number(this.visitor.id);
      }
      this.visitorCh = this.visitor.children;


      this.visitor.children = this.visitor.children.map(child => ({
        ...child,
        birthDate: child.birthDate ? child.birthDate.split('T')[0] : ''
      }));

      console.log("Visitor preuzet iz state-a:", this.visitor);

    } else if (visitorId) {

      this.birthdayAdd.VisitorId = parseInt(visitorId);
      this.getVisitorFromList(parseInt(visitorId)).subscribe(visitor => {
        if (visitor) {
          this.visitor = visitor;
          if (visitor?.id) {
            this.currentVisitorId = Number(visitor.id);
          }
          this.visitorCh = this.visitor.children;

          this.visitor.children = this.visitor.children.map(child => ({
            ...child,
            birthDate: child.birthDate ? child.birthDate.split('T')[0] : ''
          }));
        } else {

          this.roomService.getAllPlayroomsSub().subscribe(data => {
            this.playroom = data;
            this.userList = this.commonMethodsService.mapPlayroomsToUserList(this.playroom);

            if (this.birthdayAdd.city !== null || '') {
              const foundUser = this.userList.find(u => u.display === this.birthdayAdd.city);
              if (foundUser) {
                this.selectedUser = foundUser;
                this.getReducedArray();

                if (this.birthdayAdd.roomId && this.roomList) {
                  const foundRoom = this.roomList.find(
                    r => parseInt(r.value) === this.birthdayAdd.roomId
                  );
                  if (foundRoom) {
                    this.selectedRoom = foundRoom;
                  }
                }
              }
              this.getReducedZoneArray();
            }
          });
        }
      });
    }

    else {
      //prepare empty visitor for create mode
      this.visitor = {
        fullName: '',
        phone: localStorage.getItem('phoneNum'),
        email: '',
        visitorStatus: 0,
        comment: ''
      } as any;
      this.createChildren = [{ fullName: '', birthDate: '' }];
    }

    const Calldatedate = Date.now()
    const CalllDate = new Date(Calldatedate);
    const CallfromDate = new Date(Date.UTC(
      CalllDate.getFullYear(),
      CalllDate.getMonth(),
      CalllDate.getDate(),
      0, 0, 0
    ));
    this.birthdayAdd.CallStatus = 2
    this.birthdayAdd.advancePaymentWill = 0
    this.birthdayAdd.CallDate = CalllDate
    this.datumpoziva = this.formatDateForInput(this.birthdayAdd.CallDate)


    this.birthdayListService.birthdayPagination$.subscribe(pagSettings => {
      this.paginationSettingsBirthday = { ...pagSettings }; // ← kopija
    });

    this.callListService.callPagination$.subscribe(pagSettings => {
      this.paginationSettingsCalls = { ...pagSettings }; // ← kopija
    });


    this.uploadBirthdayList()
    this.callListQuery.phoneQuery = this.visitor.phone
    this.loadSearchResult()

    console.log("VISITOR PHONE", this.visitor.phone)

    console.log("CALLS$", this.calls$)

  
  }

  addChild() {
    this.createChildren.push({ fullName: '', birthDate: '' });
  }

  removeChild(i: number) {
    if (this.createChildren.length > 1) {
      this.createChildren.splice(i, 1);
    }
  }

  async createVisitor() {
    type ChildInput = { fullName: string; birthDate: string };
    const DEFAULT_BIRTHDATE = '1970-01-01';

    const childrenToSend: ChildInput[] = (this.createChildren ?? [])
      .map(c => {
        const fullName = (c?.fullName ?? '').trim();
        let birth = ((c?.birthDate ?? '') + '').slice(0, 10);
        if (!birth) birth = DEFAULT_BIRTHDATE;
        return { fullName, birthDate: birth };
      })
      .filter(c => !!c.fullName);

    const formValidation = this.validateAddVisitor();
    this.errMsg = formValidation.errMsg;
    if (!formValidation.isValid) return;

    const payloadPhone = (this.inputs?.phonePrefix || '') + (this.visitor?.phone || '');

    this.visitorService
      .saveVisitor(
        { ...this.visitor, phone: payloadPhone },
        childrenToSend
      )
      .subscribe({
        next: (res: any) => {
          if (res?.id) this.visitor.id = res.id;

          if (res?.visitorStatus !== undefined && res?.visitorStatus !== null) {
            this.visitor.visitorStatus = +res.visitorStatus;
          }

          if (!this.visitor.children || !this.visitor.children.length) {
            this.visitor.children = (this.createChildren ?? []).map(c => ({
              fullName: c.fullName,
              birthDate: (c.birthDate || DEFAULT_BIRTHDATE)
            })) as any;
          }

          this.isCreateMode = false;

          this.notifierService.notify('success', 'Uspešno sačuvano.');
        },
        error: (err) => {
          console.error(err);
          this.showErrorAndRedirect?.(err);
        }
      });
  }

  validateAddVisitor() {
    const user = this.visitor;
    let errMsg: string;
    if (!user.fullName) {
      errMsg = 'Unesite ime roditelja / staratelja.';
    } else if (!user.phone) {
      errMsg = 'Unesite broj telefona.';
    } else {
      errMsg = '';
      return { isValid: true, errMsg };
    }
    return { isValid: false, errMsg };
  }

  showErrorAndRedirect(error) {
    this.notifierService.show({
      message: '' + JSON.stringify(error.error.title),
      type: 'warning',
    });
    console.log("BIRTHDAYaDD NGONIT", this.birthdayAdd)
  }

  showSuccessAndRedirect() {
    let message = '';

    this.notifierService.show({
      // eslint-disable-next-line object-shorthand
      message: message,
      type: 'success',
    });
    this.visitor = new Visitor1();
  }

  getVisitorFromList(visitorId: number) {
    return this.visitors$.pipe(
      map(visitors => visitors.find(v => v.id === visitorId) || null)
    );
  }

  get filteredChildren() {
    const children = this.visitor?.children;
    if (!Array.isArray(children)) {
      return [];
    }
    return children.filter(c => typeof c === 'object' && c?.fullName);
  }

  loadVisit() {
    this.currentPage = 1;
    this.visitService.getAllVisitsAdminManagerRoleDirect({
      currentPage: this.currentPage,
      itemsPerPage: this.itemsPerPage,
      fullNameQuery: this.fullNameQuery,
      birthDateQuery: this.birthDateQuery,
      roomQuery: this.roomQuery,
      statusQuery: this.statusQuery,
      dateQuery: this.dateQuery,
      dateQueryEnd: this.dateQueryEnd,
      enterTimeQuery: this.enterTimeQuery,
      enterTimeQueryEnd: this.enterTimeQueryEnd,
      timeZoneQuery: this.timeZoneQuery,
      gratisQuery: this.gratisQuery,
      packageTicketType: this.packageTicketType
    }).subscribe(({ visits, pagination }) => {
      this.visits = visits;
      this.paginationSettings = pagination;
      console.log(visits)
    });
  }

  formatDateForInput(date: Date | string): string {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  getCardType(value: number, hours: number): string {
    if (value === 0) {
      if (hours) {
        return 'Sat(' + hours + 'h' + ')';
      } else {
        return 'Sat';
      }
    } else if (value === 1) {
      return 'Poludnevna karta';
    } else if (value === 2) {
      return 'Dnevna karta';
    } else {
      if (hours) {
        return 'Sat(' + hours + 'h' + ')';
      } else {
        return '';
      }
    }
  }

  editVisitor() {
    this.visitorService.editVisitor(this.visitor).subscribe((res) => {
      this.visitorService.getAllVisitorsSearch({
        currentPage: this.currentPage, itemsPerPage: this.itemsPerPage, fullNameQuery: this.fullNameQuery,
        emailQuery: this.emailQuery, phoneQuery: this.phoneQuery, visitorStatusQuery: this.visitorStatusQuery, onlyChildren: this.onlyChildren,
        marketingMessageQuery: this.marketingMessageQuery, dateBirthFromQuery: this.dateBirthFromQuery, dateBirthToQuery: this.dateBirthToQuery,
        registrationDateFromQuery: this.registrationDateFromQuery, registrationDateToQuery: this.registrationDateToQuery,
        visitorBirthMonthFromQuery: this.visitorBirthMonthFromQuery, visitorBirthMonthToQuery: this.visitorBirthMonthToQuery,
        visitorBirthYearFromQuery: this.visitorBirthYearFromQuery, visitorBirthYearToQuery: this.visitorBirthYearToQuery,


      });
    }, (err) => {
      console.error(err);
    });
  }

  downloadSignature(visitor) {
    const guid = visitor.signatureUrl.split('Signature/')[1];
    this.visitorService.getSignature(guid).subscribe(res => {
      const source = URL.createObjectURL(res);
      const el = document.createElement("a");
      el.setAttribute("href", source);
      el.setAttribute("download", `${visitor.fullName.replace(/\s/g, '_')}${visitor.phone}`);
      document.body.appendChild(el);
      el.click();
      el.remove();
    })
  }

  onUserChange(event: any) {
    this.getReducedArray()
    this.zoneList = []
    this.birthdayAdd.city = this.selectedUser.display
  }

  onRoomChange(event: any) {
    this.selectedZone = null;
    this.zoneList = [];

    if (!this.selectedRoom) {
      console.warn('Nije izabrana igraonica.');
      return;
    }

    this.birthdayAdd.roomId = parseInt(this.selectedRoom.value);
    this.commonMethodsService.getEmployeesByRoom(
      this.birthdayAdd.roomId,
      this.currentPage,
      this.itemsPerPage
    ).subscribe(employees => {
      console.log('Dostavljeni zaposleni za sobu', this.birthdayAdd.roomId, employees);
      if (employees.length > 0) {
        this.birthdayAdd.EmployeeId = employees[0].id;
      }
    });
    this.getReducedZoneArray();

  }

  compareRooms(o1: RoomArray, o2: RoomArray): boolean {
    return o1 && o2 ? parseInt(o1.value) === parseInt(o2.value) : o1 === o2;
  }
  compareZone = (o1: ZoneArray, o2: ZoneArray) => {
    return o1 && o2 ? o1.value === o2.value : o1 === o2;
  };

  onZoneChange(event: any) {
    if (!this.selectedZone) {
      console.warn('selectedZone nije postavljen.');
      return;
    }

    this.birthdayAdd.BirthdayZoneId = parseInt(this.selectedZone.value);
    this.birthdayAdd.AppointmentDate = null
    const aa = this.birthdayAdd.IsFlexible

    console.log("const aa", aa)
  }

  getReducedArray() {

    this.roomList = []
    var disp = this.selectedUser?.display
    this.roomList = this.commonMethodsService.mapPlayroomsToRoomList(this.playroom, disp);
    this.zoneList = []

  }

  getReducedZoneArray() {
    if (!this.selectedRoom) {
      console.warn('selectedRoom nije postavljen, preskačem mapiranje zona.');
      this.zoneList = [];
      this.selectedZone = null;
      return;
    }

    this.rodjendanskezoneservice.getAllPlayroomZonesSub({
      currentPage: this.currentPage,
      itemsPerPage: this.itemsPerPage
    }).subscribe(data => {
      this.zone = data;

      const disp = this.selectedRoom.display;
      this.zoneList = this.commonMethodsService.mapPlayroomsToZoneList(this.zone, disp);

      if (this.zoneList.length > 0 && this.birthdayAdd.BirthdayZoneId) {
        const foundZone = this.zoneList.find(
          z => parseInt(z.value) === this.birthdayAdd.BirthdayZoneId
        );
        this.selectedZone = foundZone ?? null;
      } else {
        this.selectedZone = null;
      }

    });
  }

  onPricePerChildrenChange(event: any) {

    this.onPlannedChildNumberChange(event)
  }

  onDiscountChange(event: any) {

    this.birthdayAdd.TotalPricePaid = this.birthdayAdd.TotalPricePaidWithoutDicount - (this.birthdayAdd.TotalPricePaidWithoutDicount * this.birthdayAdd.Discount / 100)
    this.recalculateTotal()
  }
  onAvansChange(event: any) {
    console.log("Advanse changed data ", this.birthdayAdd.advancePaymentWillString)
    console.log("this.birthdayAdd.advancePaymentWill", this.birthdayAdd.advancePaymentWill)
    this.birthdayAdd.advancePaymentWill


  }

  addBirthday() {
    if (this.birthdayAdd.CallStatus !== 0 && this.birthdayAdd.CallStatus !== 5) {

      this.birthdayAdd.SavedTimeSlotId = null
      this.birthdayAdd.SavedTimeEndSlotId = null

    }

    this.birthdayAdd.VisitorId = this.visitor.id;
    console.log("dodavanje rodjendana", this.birthdayAdd.VisitorId)

    if (this.selectedRoom === null) {
      this.birthdayAdd.roomId = null
    }
    else {
      this.birthdayAdd.roomId = parseInt(this.selectedRoom.value)
    }

    if (this.selectedZone === null) {
      this.birthdayAdd.BirthdayZoneId = null
    }
    else {
      this.birthdayAdd.BirthdayZoneId = parseInt(this.selectedZone.value)
    }
    const formValidation = validateBirthDay(this.birthdayAdd);

    this.errMsg = formValidation.errMsg;

    if (formValidation.isValid) {

      this.visitorService.addRodjedan(this.birthdayAdd).subscribe((res: BirthdayOutput) => {
        const birth = res.id;

        this.updateCallStatusOnly(birth)
        this.presentToast('Rođendan je uspešno dodat.', 'success');
        this.router.navigate(
          ['admin/birthday-booking'],
          {
            replaceUrl: true,
            queryParams: {
              roomId: this.birthdayAdd.roomId,
              zoneId: this.birthdayAdd.BirthdayZoneId,
              appointmentDate: (this.birthdayAdd as any).AppointmentDate,
              birthdayStart: (this.birthdayAdd as any).BirthdayStart
            }
          }
        );
      }, (err) => {
        JSON.stringify(err.error.title);
        const message = 'Unošenje rođendana nije uspelo.';
        this.presentToast(message, 'danger');
        this.router.navigate(['admin/manage-visitors']);
      });

      this.birthdayAdd = new BirthDay()
      this.birthdayAdd.VisitorId = null;
      this.birthdayAdd.BirthdayZoneId = null
      this.selectedUser = null;
      this.errMsg = ''
      this.birthdayAdds = []
      this.addInputField()
      this.recalculateTotal()
      this.birthdayAdd.advancePaymentWillString = ''
      this.uploadBirthdayList()
    }




  }

  getStartTimeQuery(val: Date | string): string {
    const date = new Date(val);
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    return `${hours}:${minutes}`;
  }

  getEndTimeQuery(val) {
    const date = new Date(val);
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    return `${hours}:${minutes}`;

  }

  private fromUtcToLocalTime(utcTimeStr: string, dateContext: string): string {
    // Kombinuje datum konteksta sa UTC vremenom i konvertuje u lokalno vreme
    const dateOnly = dateContext.split('T')[0];
    const fullUtcStr = `${dateOnly}T${utcTimeStr}${utcTimeStr.includes('Z') ? '' : 'Z'}`;
    const localDate = new Date(fullUtcStr);
    const hours = String(localDate.getHours()).padStart(2, '0');
    const minutes = String(localDate.getMinutes()).padStart(2, '0');
    return `${hours}:${minutes}`;
  }

  onAppoitmentDateChanged() {

    this.birthdayAdd.SavedTimeSlotId = null
    this.birthdayAdd.SavedTimeSEndlotId = null
    this.errMsgInputDate = ''
    this.birthdayAdd.startTimeBirthday = null
    const appointmentDate = new Date(this.birthdayAdd.AppointmentDate);
    const fromDate = new Date(Date.UTC(
      appointmentDate.getFullYear(),
      appointmentDate.getMonth(),
      appointmentDate.getDate(),
      0, 0, 0
    ));

    const toDate = new Date(Date.UTC(
      appointmentDate.getFullYear(),
      appointmentDate.getMonth(),
      appointmentDate.getDate() + 1,
      0, 0, 0
    ));


    console.log(
      'const appointmentDate', appointmentDate,
      'this.birthdayAdd.AppointmentDate', this.birthdayAdd.AppointmentDate,
      'fromDate', fromDate,
      'toDate', toDate,

    )
    this.visitorService.getSavedTimeSlots(
      this.birthdayAdd.roomId,
      this.birthdayAdd.BirthdayZoneId,
      fromDate,
      toDate
    ).subscribe({
      next: (slots) => {
        // Konvertuj UTC slotove u lokalno vreme
        this.availibleslots = slots.map(slot => ({
          ...slot,
          start: this.fromUtcToLocalTime(slot.start, this.birthdayAdd.AppointmentDate),
          end: this.fromUtcToLocalTime(slot.end, this.birthdayAdd.AppointmentDate)
        }));
        console.log(' this.availibleslots KARTICA CONSOLE VAN NEXT', this.availibleslots)
        this.birthdayAdd.isFlexible = false;
        for (let s = 0; s < this.availibleslots.length; s++) {

          if (this.availibleslots[s].isFlexible === true) {
            this.birthdayAdd.isFlexible = true;
            break;
          }


        }
      },
      error: (error) => {

        if (error.error.errors.includes('Appoitment-day-is-less-than-call-date')) {
          this.messageError = 'Datum zakazanong rođendana ne može biti manji od datuma poziva';
          alert('Datum zakazanong rođendana ne može biti manji od datuma poziva');
          this.birthdayAdd.AppointmentDate = null
        }
        this.errMsgInputDate = this.messageError

      }

    });
    console.log(' this.availibleslots KARTICA CONSOLE VAN NEXT', this.availibleslots)
  }

  onStartTimeChanged() {

    if (this.birthdayAdd.AppointmentDate && this.birthdayAdd.startTimeBirthday) {
      console.log(' this.birthdayAdd.startTimeBirthday', this.birthdayAdd.startTimeBirthday)

      const [hours, minutes] = this.birthdayAdd.startTimeBirthday.split(':').map(Number);

      const date = new Date(this.birthdayAdd.AppointmentDate);
      date.setHours(hours, minutes, 0, 0);

      this.birthdayAdd.BirthDayStartDt = date;

      this.birthdayAdd.BirthDayStart = new Date(
        this.birthdayAdd.BirthDayStartDt
      ).toISOString();

      for (let i = 0; i < this.availibleslots.length; i++) {

        if (this.availibleslots[i].start === this.birthdayAdd.startTimeBirthday) {


          this.visitorService.getSavedTimeSlotById(this.availibleslots[i].id).subscribe({
            next: (data) => {

              console.log('Slot data:', data);
            },
            error: (error) => {
              if (error.status === 400) {
                alert('Termin je zauzet!');
                this.birthdayAdd.startTimeBirthday = null

              } else {
                console.error('Neočekivana greška:', error);
              }
            }
          });


          this.birthdayAdd.endTimeBirthday = this.availibleslots[i].end

          const [hours, minutes] = this.birthdayAdd.endTimeBirthday.split(':').map(Number);

          const date = new Date(this.birthdayAdd.AppointmentDate);
          date.setHours(hours, minutes, 0, 0);


          this.birthdayAdd.BirthDayEndsDt = date;

          this.birthdayAdd.BirthDayEnds = new Date(
            this.birthdayAdd.BirthDayEndsDt
          ).toISOString();
          console.log('this.birthdayAdd.BirthDayEnds', this.birthdayAdd.BirthDayEnds)

          this.birthdayAdd.SavedTimeSlotId = this.availibleslots[i].id
          break;
        }
      }
    }
  }

  onStartTimeChangedFlex() {
    this.birthdayAdd.SavedTimeSlotId = null
    if (this.birthdayAdd.AppointmentDate && this.birthdayAdd.startTimeBirthday) {
      console.log(' this.birthdayAdd.startTimeBirthday', this.birthdayAdd.startTimeBirthday)
      this.errMsgInputTime = '';


      const [hours, minutes] = this.birthdayAdd.startTimeBirthday.split(':').map(Number);

      const date = new Date(this.birthdayAdd.AppointmentDate);
      date.setHours(hours, minutes, 0, 0);

      this.birthdayAdd.BirthDayStartDt = date;

      this.birthdayAdd.BirthDayStart = new Date(
        this.birthdayAdd.BirthDayStartDt
      ).toISOString();

      for (let i = 0; i < this.availibleslots.length; i++) {

        if (this.availibleslots[i].start === this.birthdayAdd.startTimeBirthday) {

          this.birthdayAdd.SavedTimeSlotId = this.availibleslots[i].id
          break;

        }
      }
    }
  }


  onEndTimeChangedFlex() {

    if (this.birthdayAdd.AppointmentDate && this.birthdayAdd.endTimeBirthday) {
      console.log('this.birthdayAdd.ENDTimeBirthday', this.birthdayAdd.endTimeBirthday)
      this.errMsgInputTime = '';
      const [hours, minutes] = this.birthdayAdd.endTimeBirthday.split(':').map(Number);

      const date = new Date(this.birthdayAdd.AppointmentDate);
      date.setHours(hours, minutes, 0, 0);

      this.birthdayAdd.BirthDayEndsDt = date;

      this.birthdayAdd.BirthDayEnds = new Date(
        this.birthdayAdd.BirthDayEndsDt
      ).toISOString();
      console.log("this.birthdayAdd.BirthDayEnds IIIIII", this.birthdayAdd.BirthDayEnds)
      for (let i = 0; i < this.availibleslots.length; i++) {

        console.log("STARTSLOT U END SLOT METODI", this.birthdayAdd.SavedTimeSlotId)
        if (this.birthdayAdd.SavedTimeSlotId === null) {

          this.birthdayAdd.SavedTimeSlotId = -1
        }


        if (this.availibleslots[i].start === this.birthdayAdd.endTimeBirthday) {
          this.birthdayAdd.SavedTimeEndSlotId = this.availibleslots[i].id
          console.log("ENDSLOT U END SLOT METODI", this.birthdayAdd.SavedTimeEndSlotId)

          this.visitorService.getSavedTimeSlotByIdStartEnd(this.birthdayAdd.SavedTimeSlotId, this.birthdayAdd.SavedTimeEndSlotId).subscribe({
            next: (data) => {

              console.log('Slot data:', data);
            },
            error: (error) => {

              if (error.error.errors.includes('Slots cant be null')) {
                this.messageError = 'Morate uneti vremena početka i završetka rodjendana.';
                alert('Morate uneti vremena početka i završetka rodjendana!');
                this.birthdayAdd.endTimeBirthday = ''
                this.birthdayAdd.startTimeBirthday = null
                this.birthdayAdd.SavedTimeSlotId = null
                this.birthdayAdd.SavedTimeSEndlotId = null

              }
              else if (error.error.errors.includes('Birthday-appoitment - is- allredy-booked')) {
                this.messageError = 'Termin je zauzet.';
                alert('Termin je zauzet!');
                this.birthdayAdd.endTimeBirthday = ''
                this.birthdayAdd.startTimeBirthday = null
                this.birthdayAdd.SavedTimeSlotId = null
                this.birthdayAdd.SavedTimeSEndlotId = null
              }
              else if (error.error.errors.includes('EndTime - and- StartTime cant be same')) {
                this.messageError = 'Vreme završetka rođendana mora biti veće od vremena početka rođendana.';
                alert('Vreme završetka rođendana mora biti veće od vremena početka rođendana!');
                this.birthdayAdd.endTimeBirthday = ''
                this.birthdayAdd.startTimeBirthday = null
                this.birthdayAdd.SavedTimeSlotId = null
                this.birthdayAdd.SavedTimeSEndlotId = null

              }

              else {
                console.error('Neočekivana greška:', error);
              }
              this.errMsgInputTime = this.messageError



            }
          });
          this.birthdayAdd.SavedTimeSEndlotId = this.availibleslots[i].id
          break;
        }
      }
    }
  }

  private readUserFromStorage(): any | null {
    const STORAGE_KEYS = ['currentUser', 'loggedUser', 'user'];
    for (const key of STORAGE_KEYS) {
      const raw = localStorage.getItem(key) || sessionStorage.getItem(key);
      if (!raw) continue;
      try {
        const obj = JSON.parse(raw);
        if (obj && ('unique_name' in obj || 'nameid' in obj)) return obj;
      } catch { }
    }

    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i)!;
      try {
        const obj = JSON.parse(localStorage.getItem(key)!);
        if (obj && ('unique_name' in obj || 'nameid' in obj)) return obj;
      } catch { }
    }

    for (let i = 0; i < sessionStorage.length; i++) {
      const key = sessionStorage.key(i)!;
      try {
        const obj = JSON.parse(sessionStorage.getItem(key)!);
        if (obj && ('unique_name' in obj || 'nameid' in obj)) return obj;
      } catch { }
    }

    return null;
  }

  private fillEmployeeFromStorage(): void {
    const user = this.readUserFromStorage();
    if (!user) {
      console.warn('[fillEmployeeFromStorage] Nije pronađen user JSON u storage-u.');
      return;
    }

    this.birthdayAdd.EmployeeId = Number(user.nameid) || null;
    this.birthdayAdd.EmployName = String(user.unique_name || '');

    console.log('[fillEmployeeFromStorage] →', {
      EmployeeId: this.birthdayAdd.EmployeeId,
      EmployName: this.birthdayAdd.EmployName
    });
  }

  statusCallHelper(value: number) {
    if (value === 0) {
      return "ZAKAZAN"
    }
    else if (value === 1) {
      return "OTKAZAN"
    }
    else if (value === 2) {
      return "RASPITUJE SE"

    }
    else if (value === 3) {
      return "RAZMISLIĆE"

    }

    else if (value === 4) {
      return "POZVATI GA"

    }


  }

  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  }

  private updateCallStatusOnly(birthId: number): void {
    const callIdStr = localStorage.getItem('callId');
    if (!callIdStr) {
      console.warn('callId nije pronađen u localStorage – preskačem PUT zahtev');
      return;
    }

    const callId = Number(callIdStr);
    if (isNaN(callId)) {
      console.warn('callId je NaN – preskačem PUT zahtev');
      return;
    }
    this.callListService.setBirthdayCall(birthId, callId).subscribe({
      next: () => { },
      error: err => console.error('Greška pri ažuriranju statusa rođendana:', err)
    });

    localStorage.removeItem("callId");
  }
  selectPrefix(prefix: { code: string; flag: string }) {
    this.selectedPrefix = prefix;
    this.inputs.phonePrefix = prefix.code;
    this.dropdownOpen = false;
  }

  addInputField() {
    this.birthdayAdds.push({ name: '', quantity: '', price: 0 });

  }


  removeInputField(index: number) {
    console.log("index remove", index)
    console.log("his.birthdayAdds.length", this.birthdayAdds.length)
    console.log("this.birthDayAdssPriceTotal", this.birthDayAdssPriceTotal)

    if (this.birthdayAdds.length === 1 && index === 0 && this.birthDayAdssPriceTotal === 0) {

      return
    }

    else if (this.birthdayAdds.length === 1 && index === 0 && this.birthDayAdssPriceTotal > 0) {
      this.birthdayAdds.splice(index, 1);
      this.addInputField()
      this.recalculateTotal()

    }

    else if (index === 0 && this.birthdayAdds.length > 1 && this.birthDayAdssPriceTotal > 0) {
      this.birthdayAdds.splice(index, 1);
      this.recalculateTotal()

    }


    else if (index > 0 && this.birthdayAdds.length > 1 && this.birthDayAdssPriceTotal > 0) {
      this.birthdayAdds.splice(index, 1);
      this.recalculateTotal()


    }


  }

  onAddsPriceChange(event: any) {
    this.recalculateTotal()
  }
  private recalculateTotal() {
    this.birthDayAdssPriceTotal = 0;
    for (let j = 0; j < this.birthdayAdds.length; j++) {
      this.birthDayAdssPriceTotal += this.birthdayAdds[j].price;
    }
    console.log("Total:", this.birthDayAdssPriceTotal)
    console.log("TotalArray Adds:", this.birthdayAdds)
    this.birthdayAdd.AddsTotalNamePrices = this.birthdayAdds
    this.birthdayAdd.TotalPricePaidWithAdds = this.birthdayAdd.TotalPricePaid + this.birthDayAdssPriceTotal
    this.birthdayAdd.TotalPricePaidAdds = this.birthDayAdssPriceTotal
  }

  onPriceNumberBlur(idx: number) {
    const v = +this.birthdayAdds[idx].price;
    if (isNaN(v)) return;
    this.birthdayAdds[idx].price = Math.round((v + Number.EPSILON) * 100) / 100;
    this.onAddsPriceChange(null);
  }



  getLocalTimeFromServer(utcString: string): string {

    if (!utcString) return '';
    const date = new Date(utcString + 'Z');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${hours}:${minutes}`;
  }




  async onConfirmBirthday() {
    await this.addBirthday();
   

  }

  
  changePageCalls(pageNumber: number) {
    this.paginationSettings.currentPage = pageNumber;
    this.loadSearchResult();
  }

  async uploadBirthdayList() {
    this.birthdayListQuery.currentPage = 1;
    this.birthdayListQuery.VisitorIdQuery = this.visitor?.id ? Number(this.visitor.id) : null;
  //  this.birthdayListQuery.VisitorNameQuery = '';
  console.log("BIRTHDAYLISTQUERY", this.birthdayListQuery)
    await this.birthdayListService.getAllBirthday(this.birthdayListQuery);
  }

  async changePageBirthday(page: number) {
    const safePage = Math.max(page, 1);
    this.paginationSettingsBirthday.currentPage = page;
    this.birthdayListQuery.currentPage = page;

    try {
      const result = await Promise.race([
        this.birthdayListService.getAllBirthday(this.birthdayListQuery),
        new Promise((_, reject) =>
          setTimeout(() => reject(new Error('Timeout: server nije odgovorio na vreme')), 5000)
        )
      ]);


    } catch (err) {
      console.error('Greška pri učitavanju rođendana:', err);
    }
  }

  onPlannedChildNumberChange(event: any) {
    const planned = Number(this.birthdayAdd.PlannedChildNumber);
    const price = Number(this.birthdayAdd.pricePerChildren);
    console.log("PLANNED", planned)
    console.log("PRICE", price)


    this.birthdayAdd.TotalPricePaidWithoutDicount = planned * price;
    this.onDiscountChange(event)
    this.recalculateTotal()
  }
  onFullPriceChange(event: any) {

    this.onDiscountChange(event)
    this.recalculateTotal()
  }

 stats = [{
    totalCount: 0,
    filteredCount: 0,
    percentFiltered: 0,
    totalDurationAll: 0,
    totalDurationFiltered: 0,
    minDuration: 0,
    maxDuration: 0,
    avgDuration: 0,
    percentFilteredCalls: 0
  }];





loadSearchResult() {
    const visitorPhoneForQuery =
      (this.visitor?.phone ?? this.callListQuery.phoneQuery ?? this.phoneQuery ?? '').toString().trim();

    this.callListService.getAllCallsSearch({
      pageNumber: this.paginationSettings.currentPage,
      pageSize: this.paginationSettings.itemsPerPage,
      currentPage: this.paginationSettings.currentPage,
      itemsPerPage: this.paginationSettings.itemsPerPage,
      visitorIdQuery: null,
      operatorExtension: null,
      phoneQuery: visitorPhoneForQuery || null,
      StatusList: this.StatusList,
      dateFrom: this.callListQuery.dateFrom || null,
      dateTo: this.callListQuery.dateTo || null,
      durationFromQuery: this.callListQuery.durationFromQuery || null,
      durationToQuery: this.callListQuery.durationToQuery || null,

      PhoneCallStatusList: this.PhoneCallStatusList,

      OperatorsExtensionList: null
    }).subscribe({
      next: (res) => {
        this.stats = res;
        console.log("Operators Stats", this.stats)
      },
      error: (err) => {
        console.error('Greška pri učitavanju statistike:', err);
      }
    });
  }

 getOperatorsArray() {
    this.callListService.getOperators().subscribe({
      next: (res) => {
        this.operators = res || [];
        console.log(this.operators, "this operators")
        this.operators.forEach(op => op.selected = true);
        this.OperatorExtensionsList = this.operators.map(op => op.operaterId);
        console.log(this.OperatorExtensionsList, "this.operatorExtensionsList")
         this.reload()
       
      },
      error: (err) => console.error('Greška pri učitavanju operatera:', err),

    });

  }

 private reload() {
   this.paginationSettings.currentPage=1 ;
    this.loadSearchResult();
   
  }

}
